import { Download, Eye } from "lucide-react";

import FileSection from "@krea/shared/design-system/file-section";
import FileSectionAction from "@krea/shared/design-system/file-section/FileSectionAction";
import { toast } from "@krea/shared/design-system/utils/toast";
import { downloadFile } from "@krea/shared/utils/downloadFile";

export const AttachedFile = ({
  title,
  url,
}: {
  title: string;
  url: string;
}) => {
  return (
    <FileSection
      title={title}
      actions={
        <div className="flex items-center">
          <FileSectionAction
            title="View file"
            Icon={Eye}
            onClick={() => {
              const viewUrl = new URL(url);
              viewUrl.searchParams.set("download", "false");
              window.open(viewUrl.toString(), "_blank", "noopener,noreferrer");
            }}
          />
          <FileSectionAction
            title="Download file"
            Icon={Download}
            onClick={() =>
              downloadFile(url, title).catch(() => {
                toast.error("Failed to download file.");
              })
            }
          />
        </div>
      }
    />
  );
};
